import { COMMA, ENTER } from "@angular/cdk/keycodes";
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { MatChipInputEvent } from "@angular/material/chips";
import {
  BudgetItemService,
  BudgetLineService,
  Pagination,
} from "blg-akaun-ts-lib";
import { AppConfig } from "../../visa";
import { forkJoin, from } from "rxjs";
import { concatMap, debounceTime, distinctUntilChanged } from "rxjs/operators";
import { SubSink } from "subsink2";

@Component({
  selector: "app-select-budget-item",
  templateUrl: "./select-budget-item.component.html",
  styleUrls: ["./select-budget-item.component.css"],
})
export class SelectBudgetItemComponent implements OnInit {
  @Input() budgetItemControl = new FormControl();
  @Output() selectionChange = new EventEmitter();
  @Input() votebookGuid;
  @Input() viewModelStore;
  @Input() ColumnViewActions;
  @Input() ColumnViewSelectors;

  private subs = new SubSink();
  separatorKeysCodes: number[] = [ENTER, COMMA];
  budgetItems: any[] = [];
  toppingsControl = new FormControl([]);
  filteredBudgetItems: any[] = [];
  newFilteredBudgetItems: any[] = [];

  @ViewChild("budgetItemInput") budgetItemInput: ElementRef<HTMLInputElement>;
  budgetItemTargets: string[] = [];

  constructor(
    private budgetItemService: BudgetItemService,
    private budgetLineService: BudgetLineService
  ) {}

  ngOnInit(): void {
    this.viewModelStore
    .select(this.ColumnViewSelectors.selectAdvanceSearch_BudgetItem_Field)
    .subscribe((data) => {
      this.budgetItems = data;
    });

    let pagination = new Pagination();
    pagination.offset = 0;
    pagination.limit = 10000;
    pagination.conditionalCriteria = [
      {
        columnName: "votebook_guid",
        operator: "=",
        value: this.votebookGuid,
      },
    ];

    this.subs.sink = this.budgetLineService
      .getByCriteria(pagination, AppConfig.apiVisa)
      .pipe(
        concatMap((records) =>
          forkJoin(
            records.data.map((record) =>
              from(
                this.budgetItemService.getByGuid(
                  record.bl_fi_budget_line.budget_item_guid.toString(),
                  AppConfig.apiVisa
                )
              )
            )
          )
        )
      )
      .subscribe({
        next: (results) => {
          results.forEach((item) => {
            this.filteredBudgetItems.push(item.data.bl_fi_budget_item);
          });
          this.newFilteredBudgetItems = this.filteredBudgetItems;
          console.log("Budget Items", this.newFilteredBudgetItems); // Output the results
        },
        complete: () => {
          console.log("All requests completed.");
        },
        error: (error) => {
          console.error("An error occurred:", error);
        },
      });
    this.budgetItemControl.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((data) => this.filterBudgetItem(data));
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || "").trim();
    // Add our budgetItem
    if (value) {
      this.budgetItems.push(value);
    }

    // Clear the input value
    event.input.value = "";

    this.budgetItemControl.setValue(null);

    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_BudgetItemField({
        budgetItems: this.budgetItems,
      })
    );
  }

  remove(budgetItem: string): void {
    const index = this.budgetItems.indexOf(budgetItem);

    if (index >= 0) {
      this.budgetItems.splice(index, 1);
    }
    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_BudgetItemField({
        budgetItems: this.budgetItems,
      })
    );
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    console.log(event.option);
    this.budgetItems.push(event.option.value);
    this.budgetItemInput.nativeElement.value = "";
    this.budgetItemControl.setValue(null);
  }

  filterBudgetItem(filterValue: string) {
    filterValue = filterValue?.trim().toLowerCase(); // Remove whitespace and make it lowercase
    this.filteredBudgetItems = this.newFilteredBudgetItems.filter((option) =>
      option.code.toLowerCase().includes(filterValue)
    );
  }

  optionClicked(event: Event, budgetItem: any) {
    event.stopPropagation();
    this.toggleSelection(budgetItem);
  }

  toggleSelection(budgetItem: any) {
    console.log(budgetItem);
    budgetItem.selected = !budgetItem.selected;
    this.budgetItemInput.nativeElement.value = "";
    if (budgetItem.selected) {
      this.budgetItems.push(budgetItem);
    } else {
      const i = this.budgetItems.findIndex(
        (value) => value.guid === budgetItem.guid
      );
      this.budgetItems.splice(i, 1);
    }
    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_BudgetItemField({
        budgetItems: this.budgetItems,
      })
    );
  }

  onReset() {
    this.budgetItems = [];
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
